import { IComponentNode } from 'app/app/editor/index.functions';
import { alpha, Box, Theme } from '@mui/material';
import NodeNameLine from 'app/app/editor/tabs/elements/layout/NodeNameLine';
import { useElementIsActive } from './useElementIsActive';

export default function FlatList({ node, componentUid }: { node: IComponentNode; componentUid: string | null }) {
    const getNodes = (node: IComponentNode): Array<IComponentNode> => {
        return node.type == 'container'
            ? (node.elements?.map((n) => getNodes(n)).reduce((a, b) => a.concat(b), []) ?? [])
            : [node];
    };
    const nodeList: Array<IComponentNode> = getNodes(node);

    const activeStates = nodeList.map((node) => ({
        node,
        isActive: useElementIsActive(componentUid, node.params?.uid),
    }));

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '4px', m: 1.5 }}>
            {activeStates.map(({ node, isActive }) => {
                return (
                    <Box
                        key={node.params.uid}
                        sx={{
                            border: '1px solid',
                            borderColor: (theme: Theme) => alpha(theme.palette.text.primary, 0.08),
                            borderRadius: '8px',
                            padding: '8px 12px',
                            alignItems: 'center',
                            cursor: 'pointer',
                            display: 'flex',
                            ...(isActive && {
                                backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.08),
                                span: {
                                    color: (theme) => theme.palette.primary.main,
                                },
                            }),
                        }}
                    >
                        <NodeNameLine componentUid={componentUid} node={node} />
                    </Box>
                );
            })}
        </Box>
    );
}
